import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/auth";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import TheoryDetail from "@/pages/TheoryDetail";
import Account from "@/pages/Account";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Recover from "@/pages/Recover";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import EvidenceRecord from "@/pages/EvidenceRecord";

function App() {
  return (
    <div className="App">
      <div className="crt-scanlines" aria-hidden="true" />
      <div className="crt-vignette" aria-hidden="true" />
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/theories/:slug" element={<TheoryDetail />} />
            <Route path="/evidence/:hash" element={<EvidenceRecord />} />
            <Route path="/account" element={<Account />} />
            <Route path="/recover" element={<Recover />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
